<template>
    <div :class="`title-algin-${titleAlign} title`">
        <h3 :class="`h1-size-${titleSize}`">{{ titleText }}</h3>
        <h5 :class="`h3-size-${titleSize}`">{{ subTitle }}</h5>
    </div>
</template>

<script>
export default {
    name: "FormTitle",
    props: {
        titleText: {
            type: String,
            required: true,
        },
        subTitle: {
            type: String,
            required: true,
        },
        titleSize: {
            type: String,
            default: "24px",
        },
        titleAlign: {
            type: String,
            default: "top",
        },
        formId: {
            type: String,
            required: true,
        },
        order: {
            type: Number,
            required: true,
        }
    },
    mounted() {
        this.emitValues();
    },
    watch: {
        titleText: "emitValues",
        subTitle: "emitValues",
    },
    methods: {
        emitValues() {
            this.$emit("input", {
                titleText: this.titleText,
                subTitle: this.subTitle,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.title-algin-center {
    text-align: center !important;
}

.title-algin-right {
    text-align: right !important;
}

.h1-size-wide {
    font-size: 1.5rem !important;
}

.h3-size-wide {
    font-size: 1.2rem !important;
}

.h1-size-small {
    font-size: 1.2rem !important;
}

.h3-size-small {
    font-size: 1rem !important;
}

.title {
    padding: 10px;
    width: 100%;
    max-width: 600px;
    margin: 10px auto;
    text-align: left;

    h3 {
        margin-bottom: 5px;
        color: #2c3e50;
        font-weight: normal;
    }

    h5 {
        color: #666;
        font-weight: normal;
        margin-top: 5px;
    }

    @media (max-width: 768px) {
        width: 100%;
    }

    @media (max-width: 480px) {
        width: 100%;
        padding: 5px;
    }
}
</style>